import Vue from "vue";

import * as components from "hcl";

for (const key in components) {
    Vue.component(key, components[key]);
};

Vue.config.productionTip = true;

const hcl = {
    config: {
        debug: {
            'checkbox': true,
            'radios': true,
            'radio': true,
            'blockcontent': true,
            'initialization': true
        }
    },
    productionTip: true
};

const applyHclBlockContent = () => {
    const blockcontent = $("hcl-block-content");
    blockcontent.each((index, element) => {
        if (!hcl.productionTip && hcl.config.debug.blockcontent) {
            console.log(
                `%c HCL %c BlockContent %c`,
                'background:#e52713 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
                'background:black ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
                'background:transparent',
                index,
                element
            );
        }
        new Vue({ el: element });
    })
}

const hclInitialization = () => {
    if (!hcl.productionTip && hcl.config.debug.initialization) {
        console.log(
            `%c HCL %c Initialization %c`,
            'background:#e52713 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:black ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );
    }

    applyHclBlockContent();
}

export { hclInitialization };
